import React from 'react';
import type { ArticleSearchResult } from '../../services/articleService';

interface ArticleSuggestionItemProps {
  article: ArticleSearchResult;
  isSelected: boolean;
  onClick: () => void;
}

const StockBadge: React.FC<{ stock: number | null | undefined }> = ({ stock }) => {
  const value = stock ?? 0;
  if (value === 0) {
    return (
      <span className="inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-bold bg-red-100 text-red-700">
        Rupture
      </span>
    );
  }
  if (value <= 3) {
    return (
      <span className="inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-bold bg-orange-100 text-orange-700">
        Stock: {value}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-bold bg-green-100 text-green-700">
      Stock: {value}
    </span>
  );
};

export const ArticleSuggestionItem: React.FC<ArticleSuggestionItemProps> = ({
  article,
  isSelected,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={`px-3 py-1.5 cursor-pointer border-b border-gray-200 last:border-b-0 transition-colors duration-150 ${
        isSelected ? 'bg-amber-200 border-amber-300' : 'bg-gray-50 hover:bg-amber-100'
      }`}
    >
      <div className="flex justify-between items-start">
        <div className="flex-1 min-w-0">
          <div className="font-medium text-sm text-gray-900 truncate">{article.code}</div>
          <div className="text-xs text-gray-600 truncate">{article.name}</div>
          {article.description && (
            <div className="text-xs text-gray-500 line-clamp-1">{article.description}</div>
          )}
        </div>
        <div className="text-right ml-3 flex-shrink-0 flex flex-col items-end gap-0.5">
          {article.reference && (
            <div className="text-xs text-gray-500">Réf: {article.reference}</div>
          )}
          <div className="flex items-center gap-1">
            <StockBadge stock={article.stock} />
            {(article.reserved_stock ?? 0) > 0 && (
              <span className="inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-bold bg-blue-100 text-blue-700">
                Réservés: {article.reserved_stock}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
